import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import MusicOptions from './MusicOptions';
import PlayingMusic from './PlayingMusic';

export default class Service1230 extends Component {
  /**************
   * Properties *
   **************/

  /**
   * The service's different screens
   */
  bannerVisible = {
    visible: false
  };
  screenSaver = {
    id: 'screenSaver',
    src: require('./images/ScreenSaver.png')
  };
  selectGenre = {
    id: 'selectGenre',
    src: require('./images/1230_SelectGenre.png'),
    top: 465,
    left: 120,
    width: 325,
    height: 69
  };
  currentlyPlaying = {
    id: 'currentlyPlaying',
    src: require('./images/1230_NowPlaying.png'),
    top: 426,
    left: 69,
    width: 423,
    height: 183
  };
  musicNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: '/main_menu'
  };
  energyNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: '/music'
  };
  playingNavigationBar = {
    mainMenu: false,
    back: false,
    backRoute: '/music/rock'
  };
  playingButtons = [];
  musicButtons = [
    {
      id: 'rock',
      to: '/music/rock/playing',
      highlight: require('./images/1230_Music_Rock_HL.png')
    },
    {
      id: 'top40',
      to: '/music/top40/playing',
      highlight: require('./images/1230_Music_Top40_HL.png')
    },
    {
      id: 'rnb',
      to: '/music/rnb/playing',
      highlight: require('./images/1230_Music_R&B_HL.png')
    },
    {
      id: 'country',
      to: '/music/country/playing',
      highlight: require('./images/1230_Music_Country_HL.png')
    },
    {
      id: 'jazz',
      to: '/music/jazz/playing',
      highlight: require('./images/1230_Music_Jazz_HL.png')
    },
    {
      id: 'Classical',
      to: '/music/classical/playing',
      highlight: require('./images/1230_Music_Classical_HL.png')
    },
    {
      id: 'kidsTween',
      to: '/music/kidstween/playing',
      highlight: require('./images/1230_Music_KidsTween_HL.png')
    },
    {
      id: 'kidsYoung',
      to: '/music/kidsyoung/playing',
      highlight: require('./images/1230_Music_KidsYoungChild_HL.png')
    }
  ];
  musicHeader = {
    id: 'header',
    src: require('./images/genres/1230_elements_Music.png')
  };
  musicButtonList = {
    top: 75,
    left: 65
    
  };
  energyHeader = {
    id: 'header',
    src: require('./images/energy/1230_elements_Energy.png')
  };
  // energyButtons = [
  //   {
  //     id: 'classicCountry',
  //     to: '/music/energy/classic_country',
  //     highlight: require('./images/energy/Energy_ClassicCountry_HL.png'),
  //     unhighlight: require('./images/energy/Energy_ClassicCountry_UH.png'),
  //     desc: require('./images/energy/Energy_ClassicCountry_desc.png'),
  //     alt: 'Classic Country'
  //   },
  //   {
  //     id: 'easyListening',
  //     to: '/music/energy/easy_listening',
  //     highlight: require('./images/energy/Energy_EasyListening_HL.png'),
  //     unhighlight: require('./images/energy/Energy_EasyListening_UH.png'),
  //     desc: require('./images/energy/Energy_EasyListening_desc.png'),
  //     alt: 'Easy Listening'
  //   },
  //   {
  //     id: 'rockNroll',
  //     to: '/music/energy/rock_n_roll',
  //     highlight: require('./images/energy/Energy_RocknRoll_HL.png'),
  //     unhighlight: require('./images/energy/Energy_RocknRoll_UH.png'),
  //     desc: require('./images/energy/Energy_RocknRoll_desc.png'),
  //     alt: 'Rock N Roll'
  //   },
  //   {
  //     id: 'classicRnB',
  //     to: '/music/energy/classic_r_n_b',
  //     highlight: require('./images/energy/Energy_RB_HL.png'),
  //     unhighlight: require('./images/energy/Energy_RB_UH.png'),
  //     desc: require('./images/energy/Energy_RB_desc.png'),
  //     alt: 'Classic R & B'
  //   },
  //   {
  //     id: 'smoothJazz',
  //     to: '/music/energy/smooth_jazz',
  //     highlight: require('./images/energy/Energy_SmoothJazz_HL.png'),
  //     unhighlight: require('./images/energy/Energy_SmoothJazz_UH.png'),
  //     desc: require('./images/energy/Energy_SmoothJazz_desc.png'),
  //     alt: 'Smooth Jazz'
  //   }
  // ];
  playingEnergyButtons = [
    {
      id: 'rock',
      to: '/music/rock/playing',
      highlight: require('./images/1230_Music_Rock_HL.png')
    },
    {
      id: 'top40',
      to: '/music/top40/playing',
      highlight: require('./images/1230_Music_Top40_HL.png')
    },
    {
      id: 'rnb',
      to: '/music/rnb/playing',
      highlight: require('./images/1230_Music_R&B_HL.png')
    },
    {
      id: 'country',
      to: '/music/country/playing',
      highlight: require('./images/1230_Music_Country_HL.png')
    },
    {
      id: 'jazz',
      to: '/music/jazz/playing',
      highlight: require('./images/1230_Music_Jazz_HL.png')
    },
    {
      id: 'Classical',
      to: '/music/classical/playing',
      highlight: require('./images/1230_Music_Classical_HL.png')
    },
    {
      id: 'kidsTween',
      to: '/music/kidstween/playing',
      highlight: require('./images/1230_Music_KidsTween_HL.png')
    },
    {
      id: 'kidsYoung',
      to: '/music/kidsyoung/playing',
      highlight: require('./images/1230_Music_KidsYoungChild_HL.png')
    }
  ];

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1230">
        <Switch>
          <Route path="/music/top40/playing" render={() => <Redirect to="/music/rock/playing" />} />
          <Route path="/music/rnb/playing" render={() => <Redirect to="/music/rock/playing" />} />
          <Route path="/music/country/playing" render={() => <Redirect to="/music/rock/playing" />} />
          <Route path="//music/jazz/playing" render={() => <Redirect to="/music/rock/playing" />} />
          <Route path="/music/classical/playing" render={() => <Redirect to="/music/rock/playing" />} />
          <Route path="/music/kidstween/playing" render={() => <Redirect to="/music/rock/playing" />} />
          <Route path="/music/kidsyoung/playing" render={() => <Redirect to="/music/rock/playing" />} />
          <Route
            path="/music/rock/playing"
            render={routeProps => (
              <PlayingMusic
                {...routeProps}
                header={this.screenSaver}
                navigationBar={this.playingNavigationBar}
              />
            )}
          />
          <Route
            path="/music/rock"
            render={routeProps => (
              <MusicOptions
                {...routeProps}
                header={this.energyHeader}
                banner={this.bannerVisible}
                text={this.currentlyPlaying}
                navigationBar={this.energyNavigationBar}
                imageButtonsList={this.musicButtonList}
                imageButtons={this.playingEnergyButtons}
              />
            )}
          />
          <Route
            path="/music/energy"
            render={routeProps => (
              <MusicOptions
                {...routeProps}
                header={this.energyHeader}
                banner={this.bannerVisible}
                text={this.selectGenre}
                navigationBar={this.energyNavigationBar}
                imageButtonsList={this.musicButtonList}
                imageButtons={this.energyButtons}
              />
            )}
          />
          <Route
            path="/music"
            render={routeProps => (
              <MusicOptions
                {...routeProps}
                header={this.musicHeader}
                banner={this.bannerVisible}
                text={this.selectGenre}
                navigationBar={this.musicNavigationBar}
                imageButtonsList={this.musicButtonList}
                imageButtons={this.musicButtons}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}
